import React, { useState } from 'react';
import { Container, ContainerItens } from './styles';
import { Divider } from '@material-ui/core';

// import { Container } from './styles';

function Dicas() {
  const [modalItens] = useState([{
    busca: 'Todos documentos que possuam no texto as palavras "licença" e "doença"',
    sugestao: 'Digitar na caixa "Busque palavra ou frase dentro do texto": licença e doença'
  },
  {
    busca: 'Todos documentos que possuam no texto as palavras "instalar" ou "salário"',
    sugestao: 'Digitar na caixa "Busque palavra ou frase dentro do texto": instalar ou salário'
  }
  ])
  return (
    <Container elevation={2}>
      {modalItens.map(item => 
        <ContainerItens>
          <p><b>O que eu quero buscar:</b> {` ${item.busca}`} </p>
          <p><b>Sugestão:</b> {` ${item.sugestao}`} </p>
          <Divider />
        </ContainerItens>
        )}
    </Container>
  );
}

export default Dicas;